import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/analytics';
const firebaseConfig = {
    apiKey: "AIzaSyBaFnex9KDorp93BUmrgmDf-An4DOwKAFY",
    authDomain: "nnncalendar-de7ef.firebaseapp.com",
    projectId: "nnncalendar-de7ef",
    storageBucket: "nnncalendar-de7ef.appspot.com",
    messagingSenderId: "55731290158",
    appId: "1:55731290158:web:1bfaf77498c4fdaf915fbf",
    measurementId: "G-L3GXM3JQ0H"
  };

firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const analytics = firebase.analytics();
export default firebase;

